module.exports = __webpack_public_path__ + "img/iphone_mockup.7089d402.png";